// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msm-paper {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(6, 21, 36, 0.22) !important;
}

.msm {
  font-family: Lato, sans-serif;
  color: #0b1e2d;
  background: #fff;
}

.msm-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 22px 8px;
}

.msm-eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #5f7484;
}

.msm-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0b1e2d;
}

.msm-sub {
  margin: 8px 0 0;
  max-width: 48ch;
  font-size: 14px;
  line-height: 1.5;
  color: #5f7484;
}

.msm-score-card {
  margin: 12px 22px 0;
  padding: 18px;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7fafa 0%, #fff 70%);
}

.msm-score-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.msm-score-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5f7484;
}

.msm-score-value {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.msm-score-input {
  width: 88px;
  border: 1px solid #dfe7e8;
  border-radius: 8px;
  background: #fff;
  padding: 8px 10px;
  font-family: Lato, sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #076b5c;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.msm-score-input:focus {
  outline: none;
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.16);
}

.msm-score-max {
  font-size: 15px;
  font-weight: 500;
  color: #8a9ba7;
}

.msm-slider-wrap {
  margin-bottom: 16px;
}

.msm-slider {
  appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 99px;
  outline: none;
  cursor: pointer;
}

.msm-slider::-webkit-slider-thumb {
  appearance: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #0d9b87;
  box-shadow: 0 2px 8px rgba(6, 21, 36, 0.18);
  cursor: grab;
}

.msm-slider::-moz-range-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #0d9b87;
  box-shadow: 0 2px 8px rgba(6, 21, 36, 0.18);
  cursor: grab;
}

.msm-slider-ticks {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.msm-tick {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #5f7484;
  font-size: 12px;
  font-weight: 700;
  font-family: Lato, sans-serif;
  cursor: pointer;
}

.msm-tick.is-active {
  border-color: transparent;
  background: #e1f4f0;
  color: #076b5c;
}

.msm-tick.is-disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.msm-level-card {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eaf0f0;
}

.msm-level-badge {
  flex: none;
  padding: 4px 8px;
  border-radius: 6px;
  background: #e1f4f0;
  color: #076b5c;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.msm-level-copy strong {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  color: #0b1e2d;
}

.msm-level-copy p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #5f7484;
}

.msm-cap-note {
  margin: 12px 0 0;
  font-size: 12.5px;
  color: #8a9ba7;
}

.msm-proof {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 16px 22px 0;
  padding: 14px 16px;
  border: 1px dashed #cfe0de;
  border-radius: 10px;
  background: #f7fafa;
}

.msm-proof-file {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #dfe7e8;
}

.msm-proof-ico {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #e1f4f0;
  color: #076b5c;
  flex: none;
}

.msm-proof-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.msm-proof-meta strong {
  font-size: 13.5px;
  color: #0b1e2d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.msm-proof-meta span {
  font-size: 12px;
  color: #8a9ba7;
}

.msm-proof-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #0b1e2d;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  font-family: Lato, sans-serif;
}

.msm-proof-btn:hover {
  border-color: #0d9b87;
  color: #076b5c;
}

.msm-proof-name {
  font-size: 13.5px;
  color: #5f7484;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.msm-proof-ai-hint {
  flex: 1 1 100%;
  margin: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: #076b5c;
}

.msm-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 22px 22px;
}

.msm-score-value .incyia-number-input {
  width: auto;
}

.msm-score-value .msm-score-input {
  width: 96px;
}

`, "",{"version":3,"sources":["webpack://./src/components/containers/MaturityScoringModal.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".msm-paper {\n  border-radius: 14px !important;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(6, 21, 36, 0.22) !important;\n}\n\n.msm {\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n  background: #fff;\n}\n\n.msm-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 22px 8px;\n}\n\n.msm-eyebrow {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #5f7484;\n}\n\n.msm-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0b1e2d;\n}\n\n.msm-sub {\n  margin: 8px 0 0;\n  max-width: 48ch;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #5f7484;\n}\n\n.msm-score-card {\n  margin: 12px 22px 0;\n  padding: 18px;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #f7fafa 0%, #fff 70%);\n}\n\n.msm-score-top {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.msm-score-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5f7484;\n}\n\n.msm-score-value {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.msm-score-input {\n  width: 88px;\n  border: 1px solid #dfe7e8;\n  border-radius: 8px;\n  background: #fff;\n  padding: 8px 10px;\n  font-family: Lato, sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  color: #076b5c;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.msm-score-input:focus {\n  outline: none;\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.16);\n}\n\n.msm-score-max {\n  font-size: 15px;\n  font-weight: 500;\n  color: #8a9ba7;\n}\n\n.msm-slider-wrap {\n  margin-bottom: 16px;\n}\n\n.msm-slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 8px;\n  border-radius: 99px;\n  outline: none;\n  cursor: pointer;\n}\n\n.msm-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fff;\n  border: 3px solid #0d9b87;\n  box-shadow: 0 2px 8px rgba(6, 21, 36, 0.18);\n  cursor: grab;\n}\n\n.msm-slider::-moz-range-thumb {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fff;\n  border: 3px solid #0d9b87;\n  box-shadow: 0 2px 8px rgba(6, 21, 36, 0.18);\n  cursor: grab;\n}\n\n.msm-slider-ticks {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.msm-tick {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #5f7484;\n  font-size: 12px;\n  font-weight: 700;\n  font-family: Lato, sans-serif;\n  cursor: pointer;\n}\n\n.msm-tick.is-active {\n  border-color: transparent;\n  background: #e1f4f0;\n  color: #076b5c;\n}\n\n.msm-tick.is-disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.msm-level-card {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #eaf0f0;\n}\n\n.msm-level-badge {\n  flex: none;\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: #e1f4f0;\n  color: #076b5c;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.msm-level-copy strong {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 14px;\n  color: #0b1e2d;\n}\n\n.msm-level-copy p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.msm-cap-note {\n  margin: 12px 0 0;\n  font-size: 12.5px;\n  color: #8a9ba7;\n}\n\n.msm-proof {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 16px 22px 0;\n  padding: 14px 16px;\n  border: 1px dashed #cfe0de;\n  border-radius: 10px;\n  background: #f7fafa;\n}\n\n.msm-proof-file {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n}\n\n.msm-proof-ico {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: #e1f4f0;\n  color: #076b5c;\n  flex: none;\n}\n\n.msm-proof-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.msm-proof-meta strong {\n  font-size: 13.5px;\n  color: #0b1e2d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.msm-proof-meta span {\n  font-size: 12px;\n  color: #8a9ba7;\n}\n\n.msm-proof-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #0b1e2d;\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: Lato, sans-serif;\n}\n\n.msm-proof-btn:hover {\n  border-color: #0d9b87;\n  color: #076b5c;\n}\n\n.msm-proof-name {\n  font-size: 13.5px;\n  color: #5f7484;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.msm-proof-ai-hint {\n  flex: 1 1 100%;\n  margin: 0;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #076b5c;\n}\n\n.msm-foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 18px 22px 22px;\n}\n\n.msm-score-value .incyia-number-input {\n  width: auto;\n}\n\n.msm-score-value .msm-score-input {\n  width: 96px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
